import React, { Component } from 'react';
import { getWindowUrlParams } from '../../../utils/url';
import { getInitialLoginData } from '../api';
import { actionTypeEnum, AuthenticationContext } from '../consts';

const AuthenticationInitialDataController = (OriginalComponent) =>
	class extends Component {
		state = {
			authenticationInitialData: {
				action: null,
				hasAdfs: false,
				shouldRequestTiles: false,
				redirectUrl: null,
				tiles: '',
			},
			isPending: true,
			email: null,
		};

		componentDidMount() {
			this.fetchAuthData();
		}

		get providerValue() {
			return {
				forgotPasswordEmail: this.state.email,
				saveEmailForForgotPassword: this.saveEmailForForgotPassword,
			};
		}

		get portalData() {
			const authenticationEntryEl = document.getElementById('authentication-entry');

			if (authenticationEntryEl === null) {
				return null;
			}

			try {
				return {
					...JSON.parse(authenticationEntryEl.dataset.authenticationPortalData),
				};
			} catch (e) {
				console.log('authentication-portal-data can not be parse');

				return null;
			}
		}

		fetchAuthData = () => {
			const windowUrlParams = getWindowUrlParams({ toLowerCase: true });

			const loginParams = {
				email: windowUrlParams.email,
				redirecturl: windowUrlParams.redirecturl,
				deeplinkid: windowUrlParams.deeplinkid,
			};

			this.setState(loginParams);

			const { email, redirecturl, deeplinkid } = loginParams;

			getInitialLoginData({
				email,
				redirecturl,
				deeplinkid,
			})
				.then((response) => {
					this.handleAuthenticationResponse(response.data);
				})
				.catch(
					({
						response: {
							data: { errors },
						},
					}) => {
						if (errors.deepLinkId) {
							this.handleAuthenticationResponse({
								action: actionTypeEnum.WRONG_DEEPLINK,
							});
						}
						if (errors._) {
							console.log(errors._);
							if (errors._.cannotChangePasswordUseADFS) {
								this.handleAuthenticationResponse({
									action: actionTypeEnum.WRONG_LOGIN_USE_ADFS,
								});
							}
							if (errors._.personalDataNotFound) {
								this.handleAuthenticationResponse({
									action: actionTypeEnum.PERSONAL_DATA_NOT_FOUND,
								});
							}
						}
					},
				)
				.then(this.handleAuthenticationPending);
		};

		handleAuthenticationResponse = (data = {}) => {
			this.setState({
				authenticationInitialData: data,
			});
		};

		handleAuthenticationPending = () => {
			this.setState({
				isPending: false,
			});
		};

		saveEmailForForgotPassword = (email) => {
			this.setState({
				email,
			});
		};

		componentDidCatch(error, info) {
			console.log(error, info);
		}

		render() {
			return (
				<AuthenticationContext.Provider value={this.providerValue}>
					<OriginalComponent
						{...this.state}
						{...this.props}
						portalData={this.portalData}
						fetchAuthData={this.fetchAuthData}
					/>
				</AuthenticationContext.Provider>
			);
		}
	};

export default AuthenticationInitialDataController;
